export function formatEventTime(startsAt: string, endsAt?: string | null): string {
  const now = new Date();
  const startDate = new Date(startsAt);

  if (startDate <= now) {
    if (endsAt && new Date(endsAt) > now) return 'LIVE NOW';
    return 'Ended';
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const formatTime = (date: Date): string => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const formatDate = (date: Date): string => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  };

  if (startDate >= today && startDate < tomorrow) {
    return `Today ${formatTime(startDate)}`;
  } else if (startDate >= tomorrow && startDate < new Date(tomorrow.getTime() + 86400000)) {
    return `Tomorrow ${formatTime(startDate)}`;
  } else {
    return `${formatDate(startDate)} ${formatTime(startDate)}`;
  }
}
